import { Navigate, Route, Routes } from "react-router-dom";
import { LandingPage } from "./features/landing/LandingPage";
import { AuthProvider } from "./auth/AuthContext";
import { AppShell } from "./components/layout/AppShell";
import { OnboardingGate, Protected, SuperAdminOnly, TenantAdminOnly } from "./components/layout/ProtectedRoute";
import { ToastProvider } from "./components/ToastContext";
import { AcceptInvitePage } from "./features/auth/AcceptInvitePage";
import { ForgotPasswordPage } from "./features/auth/ForgotPasswordPage";
import { LoginPage } from "./features/auth/LoginPage";
import { SignUpPage } from "./features/auth/SignUpPage";
import { ResetPasswordPage } from "./features/auth/ResetPasswordPage";
import { DashboardPage } from "./features/dashboard/DashboardPage";
import { ProfilePage } from "./features/profile/ProfilePage";
import { OnboardingPage } from "./features/onboarding/OnboardingPage";
import { HelpPage } from "./features/help/HelpPage";
import { SubscribePage } from "./features/billing/SubscribePage";
import { PaymentsPage } from "./features/admin/PaymentsPage";
import { HistoryPage } from "./features/history/HistoryPage";
import { NotebookPage } from "./features/notebook/NotebookPage";
import { CourseDetailPage } from "./features/learning/CourseDetailPage";
import { ReferencePage } from "./features/learning/ReferencePage";
import { StorePage } from "./features/learning/StorePage";
import { CoursesPage } from "./features/learning/CoursesPage";
import { LessonPlayerPage } from "./features/learning/LessonPlayerPage";
import { ExamItemPlayerPage } from "./features/practice/ExamItemPlayerPage";
import { MockExamPage } from "./features/practice/MockExamPage";
import { PartItemsPage } from "./features/practice/PartItemsPage";
import { ReviewPage } from "./features/practice/ReviewPage";
import { SpeakingBotPage } from "./features/practice/SpeakingBotPage";
import { LiveVoicePage } from "./features/practice/LiveVoicePage";
import { PracticeCenterPage } from "./features/practice/PracticeCenterPage";
import { MonumentGalleryPage } from "./features/practice/monuments/MonumentGalleryPage";
import { AiSettingsPage } from "./features/admin/AiSettingsPage";
import { AiUsagePage } from "./features/admin/AiUsagePage";
import { OrdersPage } from "./features/admin/OrdersPage";
import { TenantDetailPage } from "./features/admin/TenantDetailPage";
import { TenantsPage } from "./features/admin/TenantsPage";
import { BillingPage } from "./features/billing/BillingPage";
import { RevenuePage } from "./features/billing/RevenuePage";
import { AccessPage } from "./features/team/AccessPage";
import { ClassesPage } from "./features/team/ClassesPage";
import { TeamPage } from "./features/team/TeamPage";
import { I18nProvider } from "./i18n";
import { PlacementPage } from "./features/learning/PlacementPage";

export function App() {
  return (
    <I18nProvider>
      <ToastProvider>
        <AuthProvider>
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/signup" element={<SignUpPage />} />
            <Route path="/forgot-password" element={<ForgotPasswordPage />} />
            <Route path="/reset-password" element={<ResetPasswordPage />} />
            <Route path="/accept-invite" element={<AcceptInvitePage />} />

            <Route element={<Protected />}>
              {/* Onboarding stands alone: protected, but outside the gate (so
                  it's reachable) and outside the AppShell chrome. */}
              <Route path="/onboarding" element={<OnboardingPage />} />
              <Route element={<OnboardingGate />}>
              <Route element={<AppShell />}>
                <Route path="/dashboard" element={<DashboardPage />} />
                <Route path="/profile" element={<ProfilePage />} />
                <Route path="/ai-usage" element={<AiUsagePage />} />
                <Route path="/learn" element={<CoursesPage />} />
                <Route path="/learn/courses/:courseId" element={<CourseDetailPage />} />
                <Route path="/learn/lessons/:lessonId" element={<LessonPlayerPage />} />
                <Route path="/reference" element={<ReferencePage />} />
                <Route path="/notebook" element={<NotebookPage />} />
                <Route path="/history" element={<HistoryPage />} />
                <Route path="/help" element={<HelpPage />} />
                <Route path="/subscribe" element={<SubscribePage />} />
                <Route path="/payments" element={<PaymentsPage />} />
                <Route path="/placement" element={<PlacementPage />} />
                <Route path="/store" element={<StorePage />} />
                <Route path="/practice" element={<PracticeCenterPage />} />
                <Route path="/speak" element={<SpeakingBotPage />} />
                <Route path="/speak/live" element={<LiveVoicePage />} />
                <Route path="/practice/items/:itemId" element={<ExamItemPlayerPage />} />
                <Route path="/practice/:board/:level/exam" element={<MockExamPage />} />
                <Route path="/practice/:board/:level/review" element={<ReviewPage />} />
                <Route path="/practice/:board/:level/:partCode" element={<PartItemsPage />} />
                <Route path="/monuments" element={<MonumentGalleryPage />} />
                <Route element={<SuperAdminOnly />}>
                  <Route path="/tenants" element={<TenantsPage />} />
                  <Route path="/tenants/:tenantId" element={<TenantDetailPage />} />
                  <Route path="/orders" element={<OrdersPage />} />
                  <Route path="/revenue" element={<RevenuePage />} />
                  <Route path="/ai-settings" element={<AiSettingsPage />} />
                </Route>
                <Route element={<TenantAdminOnly />}>
                  <Route path="/team" element={<TeamPage />} />
                  <Route path="/classes" element={<ClassesPage />} />
                  <Route path="/access" element={<AccessPage />} />
                  <Route path="/billing" element={<BillingPage />} />
                </Route>
              </Route>
              </Route>
            </Route>

            <Route path="*" element={<Navigate to="/dashboard" replace />} />
          </Routes>
        </AuthProvider>
      </ToastProvider>
    </I18nProvider>
  );
}
